import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MenuItem } from '@shared/model/menu-item.type';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuService } from '../services/menu.service';

@Component({
  selector: 'app-sub-menu',
  imports: [RouterLink, UpperCasePipe, TranslatePipe, RouterLinkActive],
  templateUrl: './sub-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./sub-menu.component.scss'],
})
export class SubMenuComponent {
  private readonly menuService = inject(MenuService);

  protected get visibleMenus(): MenuItem[] {
    return this.menuService.subMenu()?.items.filter((menu: MenuItem) => !menu.show || menu.show());
  }

  protected handleClick(menu: MenuItem): void {
    if (menu.click) {
      menu.click();
    }
  }

  get hideSubMenu(): boolean {
    return !this.menuService.displaySubMenu();
  }

  protected trackByFn = (index: number, menu: MenuItem) => menu.label || index;
}
